import { createContext, useContext } from "react"

/** True when blocks are rendered as a preview of the next page (e.g. at the bottom of an EV Index page) */
export const NextPagePreviewContext = createContext(false)

export const useNextPagePreview = () => useContext(NextPagePreviewContext)
